<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="status" slot-scope="params">
        <span v-if="params.params.status == 1">申请报销</span>
        <span v-if="params.params.status == 2">已批准</span>
        <span v-if="params.params.status == 3">已报销</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'repair',
      breadcrumb: [
        { name: "财务管理", path: "/finance/estimatedProfit" },
        { name: "车队利润表", path: "/finance/estimatedProfit" },
        { name: "当月维保记录" },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 110 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "fleet_name", label: "车队长", minwidth: 110 },
        { keyName: "article_name", label: "维保类型", minwidth: 120 },
        { keyName: "maunit", label: "维保厂家", minwidth: 130 },
        { keyName: "rstarttime", label: "维保时间", minwidth: 120 },
        { keyName: "money", label: "维保金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "add_name", label: "填写人", minwidth: 140 },
        // { keyName: "status", label: "审批状态", slot: 'status' },
      ],
      baseParams: ['month', 'car_id', 'is_status'],
      getTotalProperty: ['money'],
    };
  },
  methods: {
    setQueryParams() {
      const { month, car_id } = this.$route.query
      this.formInline.date = month
      this.formInline.car_id = car_id;
      this.formInline.is_status = 4;
    },
  },
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 0 0 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .retrieval {
    height: 52px;
    /* overflow: hidden; */
    margin: 0px 20px;
    font-size: 14px;
    color: #606266;
    // display: flex;
    // justify-content: space-between;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
    }
  }
}
</style>
